import { ThemeContext } from '@/theme/ThemeProvider';
import { message } from 'antd';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import CoinList from './CoinList';
import * as S from './style';

interface MenuListProps {
  menu: any;
}

const TransArrow = styled.div<{ $isHover?: boolean }>`
  transition: all 0.2s ease-in-out;
  transform: ${({ $isHover }) => ($isHover ? 'rotate(180deg)' : 'none')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`;

export default function MenuList({ menu }: MenuListProps) {
  const [isHover, setIsHover] = useState(false);
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();

  const handleMouseEnter = () => setIsHover(true);
  const handleMouseLeave = () => setTimeout(() => setIsHover(false), 50);

  return (
    <S.MenuLi onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <S.Menu onClick={handleMouseLeave} to={menu.link}>
        {menu.title}{' '}
        {menu.dropdown && (
          <TransArrow $isHover={isHover}>
            <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.6667 1.16675L6.00004 5.83341L1.33337 1.16675"
                stroke={theme.COLORS.textw}
                strokeLinecap="square"
              />
            </svg>
          </TransArrow>
        )}
      </S.Menu>
      {menu.dropdown && (
        <S.SubMenuWrap className={isHover ? 'hover' : ''}>
          <S.SubMenu>
            {menu?.subMenu.map((item: any, index: number) => {
              if (item.title === t('usdtPerpetuals')) {
                return (
                  <CoinList key={index} handleMouseLeave={handleMouseLeave} />
                );
              } else {
                return (
                  <S.SubMenuList
                    key={index}
                    className={item.inactive ? 'inactive' : ''}
                  >
                    <Link
                      onClick={() => {
                        handleMouseLeave();
                        if (item.inactive) {
                          message.warning('This feature is not available yet');
                          return;
                        }
                      }}
                      to={item.inactive ? '#' : item.link}
                    >
                      <S.SubMenuFlex>
                        <div className="icon">{item.icon && item.icon}</div>
                        <div>
                          <h4>{item.title}</h4>
                          <p>{item.description}</p>
                        </div>
                      </S.SubMenuFlex>
                    </Link>
                  </S.SubMenuList>
                );
              }
            })}
          </S.SubMenu>
        </S.SubMenuWrap>
      )}
    </S.MenuLi>
  );
}
